import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EmployeeService } from '../employee.service';
import { EmployeeModel } from '../model/employee.model';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { DepartmentModel } from '../../../system/shopinfo/model/shopinfo.model';
import { EmployeeCategoryModel } from '../../employee-category/employee-category/model/employee-category.model';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-employee-edit',
  standalone: false,
  templateUrl: './employee-edit.component.html',
  styleUrl: './employee-edit.component.scss'
})
export class EmployeeEditComponent {
  title: string = "New Employee ";
  editForm: FormGroup;
  employeeInfo: EmployeeModel = {};
  isFormDirty: boolean = false;
  sameAsAbove: boolean = false;
  departmentList: DepartmentModel[] = [];
  categoryList: EmployeeCategoryModel[] = [];
  permission: any;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private employeeService: EmployeeService,
    private snackBarService: SnackBarService,
    private permissionService: PermissionService,
    public dialog: MatDialog,) {

    let employeeId = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      code: this.builder.control(this.employeeInfo.code, [Validators.required, Validators.maxLength(10)]),
      f_name: this.builder.control(this.employeeInfo.f_name, [Validators.required, Validators.maxLength(50)]),
      m_name: this.builder.control(this.employeeInfo.m_name),
      l_name: this.builder.control(this.employeeInfo.l_name),
      status: this.builder.control(this.employeeInfo.status ?? '1'),
      sex: this.builder.control(this.employeeInfo.sex),
      dob: this.builder.control(this.employeeInfo.dob, [Validators.required, this.noFutureDateValidator()]),
      doj: this.builder.control(this.employeeInfo.doj, [this.noFutureDateValidator()]),
      wage_type: this.builder.control(this.employeeInfo.wage_type, [Validators.required]),
      cost_per_hour: this.builder.control(this.employeeInfo.cost_per_hour, [Validators.required, this.nonNegativeValidator()]),
      over_time_pay_rate: this.builder.control(this.employeeInfo.over_time_pay_rate, [Validators.required, this.nonNegativeValidator()]),
      work_permit: this.builder.control(this.employeeInfo.work_permit),
      card_no: this.builder.control(this.employeeInfo.card_no, [Validators.required]),
      address: this.builder.control(this.employeeInfo.address),
      country: this.builder.control(this.employeeInfo.country),
      zip_code: this.builder.control(this.employeeInfo.zip_code),
      phone: this.builder.control(this.employeeInfo.phone, [
        Validators.pattern(/^[0-9]{7,15}$/) // allows 7-15 digits, adjust as needed
      ]),
      fax: this.builder.control(this.employeeInfo.fax),
      email: this.builder.control(this.employeeInfo.email, [Validators.email]),
      loc_address: this.builder.control(this.employeeInfo.loc_address),
      loc_country: this.builder.control(this.employeeInfo.loc_country),
      loc_zip_code: this.builder.control(this.employeeInfo.loc_zip_code),
      loc_phone: this.builder.control(this.employeeInfo.loc_phone, [
        Validators.pattern(/^[0-9]{7,15}$/) // allows 7-15 digits, adjust as needed
      ]),
      payroll_code: this.builder.control(this.employeeInfo.payroll_code, [
        Validators.required,
        Validators.maxLength(7),
        Validators.minLength(7)
      ]),
      can_export: this.builder.control(this.employeeInfo.can_export == 1),

      loc_fax: this.builder.control(this.employeeInfo.loc_fax),
      employee_category_id: this.builder.control(this.employeeInfo.employee_category_id),
      department_id: this.builder.control(this.employeeInfo.department_id, [Validators.required])
    });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    if (employeeId !== null && parseInt(employeeId) !== 0) {
      this.setemployeeInfo(employeeId);
    } else {
      this.editForm.get('payroll_code')?.clearValidators();
      this.editForm.get('payroll_code')?.updateValueAndValidity();
    }

    this.permission = this.permissionService.getRowPermission(this.permissionService.getPagePermission('employee'), employeeId);

  }
  ngOnInit(): void {
    //  this.loadRating();    
    this.loadData();
    this.CategoryLoadData();
  }

  /**
   * Dirtyness check
   * @returns 
   */
  isDirty(): boolean {
    return this.isFormDirty;

  }

  /**
   * checks the form is edited
   */
  navBack(): void {

    this.router.navigate(['/employee/employee']);

  }

  /**
   * If tas is is null set an empty area info
   * if area id is not null call api to rtrive the info
   * @param employeeId 
   */
  setemployeeInfo(employeeId: any): void {

    let response = this.employeeService.getEmployeeById(employeeId).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.employeeInfo = response.data.employee;
          if (this.employeeInfo.employee_category_id) {
            this.employeeInfo.employee_category_id = Number(this.employeeInfo.employee_category_id);
          }
          if (this.employeeInfo.department_id) {
            this.employeeInfo.department_id = Number(this.employeeInfo.department_id);
          }
          
          // Convert can_export to boolean strictly for mat-checkbox binding
          this.employeeInfo.can_export = (this.employeeInfo.can_export == 1 || this.employeeInfo.can_export === true);

          this.editForm.patchValue(this.employeeInfo);
          this.title = this.getTitle();
          this.isFormDirty = false;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get data from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  /**
   * 
   * @returns  the title for the dialog
   * sine the same dialog is used for edit and new, dynamically decide the title
   */
  getTitle(): string {
    let title = (this.employeeInfo.id == 0) ? "New Employee" : "Editing : " + this.employeeInfo.f_name;
    return title;
  }

  /**
     * On save
     * if the details are valid call the api to update the changes.
     */
  save(): void {

    if (this.editForm.valid) {
      this.editForm.markAllAsTouched();
      Object.assign(this.employeeInfo, this.editForm.value);
      console.log(this.employeeInfo);
      this.employeeService.update(this.employeeInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            // handle success
            this.isFormDirty = false;
            let snckBarData: SnackBarData = {
              type: 'success',
              title: 'Saved',
              message: 'The record for ' + this.employeeInfo.f_name + " has been updated succesfully."
            }
            this.snackBarService.openSnackBar(snckBarData);
            this.router.navigate(['/employee/employee']);

          } else if (response.code === 'DATA_CHANGED_AT_SERVER') {
            let snackBarData: SnackBarData = {
              message: 'This record has been updated by another user. Please reload the data to see the latest changes.',
              title: 'Conflict Detected',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
            // Refresh the data to show the latest version from server
            if (this.employeeInfo.id) {
              this.setemployeeInfo(this.employeeInfo.id);
            }
          } else {
            let snackBarData: SnackBarData = {
              message: response.message,
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        },
        error: (error) => {
          // handle error
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });

    } else {
      this.editForm.markAllAsTouched();
      let snackBarData: SnackBarData = {
        message: 'Please fill all required fields correctly',
        title: 'Validation Error',
        type: 'error'
      };
      this.snackBarService.openSnackBar(snackBarData);
    }


  }

  onSameAsAboveChange(checked: boolean) {
    this.sameAsAbove = checked;
    if (checked) {
      this.editForm.patchValue({
        loc_address: this.editForm.get('address')?.value,
        loc_country: this.editForm.get('country')?.value,
        loc_zip_code: this.editForm.get('zip_code')?.value,
        loc_phone: this.editForm.get('phone')?.value,
        loc_fax: this.editForm.get('fax')?.value,
      });
    } else {
      this.editForm.patchValue({
        loc_address: '',
        loc_country: '',
        loc_zip_code: '',
        loc_phone: '',
        loc_fax: '',
      });
    }
  }

  loadData(): void {
    let requestData = { "search": { "filters": { "simpleSearch": [], "advSearch": [], "scope": { "limit": 1000, "offset": 0 } }, "sort": [{ "column": "name", "order": "asc" }] } }
    let response = this.employeeService.getDepartmentList(requestData).subscribe(response => {
      if (response.status == 'SUCCESS') {

        this.departmentList = response.data.departments;

      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }

    });

  }


  CategoryLoadData(): void {
    let requestData = { "search": { "filters": { "simpleSearch": [], "advSearch": [], "scope": { "limit": 1000, "offset": 0 } }, "sort": [{ "column": "name", "order": "asc" }] } }

    let response = this.employeeService.getEmployeeCategoryList(requestData).subscribe(response => {
      if (response.status == 'SUCCESS') {
        this.categoryList = response.data.employees;

      }

    });

  }

  // Custom validator function
  noFutureDateValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const value = control.value;
      if (!value) return null;
      const inputDate = new Date(value);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Ignore time
      if (inputDate > today) {
        return { futureDate: true };
      }
      return null;
    };
  }

  // Non-negative validator
  nonNegativeValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      if (control.value == null || control.value === '') return null;
      return Number(control.value) < 0 ? { negative: true } : null;
    };
  }

}
